import React, { useState, useEffect } from 'react';
import { CountDownWrapper, H2, H1 } from './elements';
import { getMonth, getDate, getDay, getHours, getFullYear } from 'utils/moment';

export const CountDown = ({ startTime }) => {
  const difference = +new Date(startTime) - +new Date();
  const calculateTimeLeft = () => {
    const minTowDigits = n => {
      return (n < 10 ? '0' : '') + n;
    };
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: minTowDigits(Math.floor(difference / (1000 * 60 * 60 * 24))),
        hours: minTowDigits(Math.floor((difference / (1000 * 60 * 60)) % 24)),
        minutes: minTowDigits(Math.floor((difference / 1000 / 60) % 60)),
        seconds: minTowDigits(Math.floor((difference / 1000) % 60))
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const timeInSeconds = Math.floor((difference / 1000 / 60) * 60);

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
      timeInSeconds === 0 && window.location.reload();
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft]);

  const { days, hours, minutes, seconds } = timeLeft;

  const StartDay = getDay(startTime);
  const StartDate = getDate(startTime);
  const StartMonth = getMonth(startTime);
  const Year = getFullYear(startTime);
  return (
    <CountDownWrapper>
      <H2>STAY TUNED</H2>
      <div>
        <h2>
          <span>LIVE</span> STREAM
        </h2>
        <h2>BEGINS IN</h2>
        <H1>
          {Object.keys(timeLeft).length ? (
            `${days}:${hours}:${minutes}:${seconds}`
          ) : (
            <span>Time's up!</span>
          )}
        </H1>
      </div>
      <h5>
        {`Live stream premiers on ${StartDay}, ${StartDate} ${StartMonth} ${Year} -
        ${getHours(startTime).toUpperCase()} EAT`}
      </h5>
    </CountDownWrapper>
  );
};

export default CountDown;
